import DateFormatResolver from 'resolvers/date-format.resolver';

const averageRatingsLabel = 'Average Rating';
const ratedCallsCountsLabel = 'Number of calls that received a rating';

export default (data = [], granularity) => {
	const dateFormat = granularity === 'hour' ? 'hA' : 'DD MMM `YY';
	const averageRatings = [];
	const ratedCallsCounts = [];
	const labels = [];

	for (let i = 0; i < data.length; i += 1) {
		averageRatings.push(data[i].averageRating);
		ratedCallsCounts.push(data[i].ratedCallsCount);
		labels.push(DateFormatResolver.resolve(data[i].timeSlot, dateFormat));
	}

	return {
		data: {
			datasets: [
				{
					yAxisID: 'left',
					label: ratedCallsCountsLabel,
					data: ratedCallsCounts,
					backgroundColor: '#00bcd4',
					order: 2,
				},
				{
					label: averageRatingsLabel,
					data: averageRatings,
					type: 'line',
					borderColor: '#F79700',
					pointBackgroundColor: '#F79700',
					fill: false,
					lineTension: false,
					yAxisID: 'right',
					order: 1,
				},
			],
			labels,
		},
		options: {
			plugins: {
				datalabels: {
					display: false,
				},
			},
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false,
			},
			scales: {
				xAxes: [
					{
						barPercentage: 0.2,
						scaleShowGridLines: true,
						ticks: {
							fontColor: 'rgba(0, 0, 0, 0.2)',
							fontSize: 14,
						},
						gridLines: {
							display: false,
						},
					},
				],
				yAxes: [
					{
						id: 'left',
						ticks: {
							min: 0,
							stepSize: 1,
							beginAtZero: true,
							fontColor: '#00bcd4',
							fontSize: 14,
						},
						gridLines: {
							display: true,
							drawBorder: false,
							borderDash: [2, 2],
							color: 'rgba(0, 0, 0, 0.2)',
						},
					},
					{
						id: 'right',
						position: 'right',
						ticks: {
							max: 5,
							min: 0,
							beginAtZero: true,
							fontColor: '#f79700',
							fontSize: 14,
						},
						gridLines: {
							display: false,
							drawBorder: false,
						},
					},
				],
			},
		},
		customLegend: [
			{
				color: '#00bcd4',
				text: ratedCallsCountsLabel,
			},
			{
				color: '#f79700',
				text: averageRatingsLabel,
			},
		],
		type: 'bar',
		hasData: labels.length > 0,
	};
};
